export default __webpack_public_path__ + "static/MineralSwimV2_Testimonial_Well_Nourished-ae0f5b1fb19219fec2024e8c9f89aa0c.jpg";